require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-4-ways-that-technology-will-disrupt-your-legal-firm.json") })
        }
      }, "path---blog-4-ways-that-technology-will-disrupt-your-legal-firm");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-4-ways-that-technology-will-disrupt-your-legal-firm!./.cache/json/blog-4-ways-that-technology-will-disrupt-your-legal-firm.json
// module id = 803
// module chunks = 231608221292675